export default __webpack_public_path__ + "static/media/confused.ac56f272.svg";